export default {
    // api: "http://192.168.2.12:8086",
    // api: "http://192.168.10.36:8086",
    // 测试地址
    // api: "https://test.aiteyixia.cn",
    // 生产地址
    api: "https://app.aiteyixia.cn/"
}


// WEBPACK FOOTER //
// ./src/serve.js